import ProxyCallout from "../../../../contents/docs/advanced/_snippets/proxy-callout.mdx";
import { Steps, Step } from 'components/Docs/Steps';
import * as React from 'react';
export default {
  ProxyCallout,
  Steps,
  Step,
  React
};